import React, { Component } from 'react'
import { connect } from 'react-redux'

// Actions
import { triggerPopup } from '../../../actions/backdrop'
import { setHeaderInfo } from '../../../actions/common'

// Utils
import { hasAccess, hasSubscriptionPermission } from '../../../utils/auth'
import { translation } from '../../../utils/helpers'

import { SparePartModuleIcons } from '../../elements/icons'

// Elements
import PanelHeader from '../../elements/panelHeader'
import Grid from '../../elements/grid'
import NewForsiRPModal from '../../modals/NewForsiRPModal'
import StatusBox from '../StatusBox'

import { SET_HEADERINFO_FORSI } from '../../../constants'

class ForsiCreateReport extends Component {
  constructor (props) {
    super(props)
    this.state = {
      showForsiCreatePopup: false,
      showSpinner: false,
      isCreated: false,
      draft: null
    }
    this.updateSpinner = this.updateSpinner.bind(this)
    this.handleSuccess = this.handleSuccess.bind(this)
    this.handleTokenExpired = this.handleTokenExpired.bind(this)
    this.handleForsiPopup = this.handleForsiPopup.bind(this)
  }

  handleForsiPopup (e) {
    const value = !this.state.showForsiCreatePopup
    this.props.triggerPopup(value)
    this.setState({
      showForsiCreatePopup: value,
      showSpinner: !this.state.showSpinner
    })
  }

  handleSuccess (draft) {
    const value = !this.state.showForsiCreatePopup
    this.props.triggerPopup(value)
    this.setState({
      showForsiCreatePopup: value,
      showSpinner: !this.state.showSpinner,
      isCreated: true,
      draft
    }, () => {
      // window.toastr.success(translation('16491'), translation('13424'))
      if (this.props.onSuccess !== null) {
        this.props.onSuccess()
      }
    })
  }

  handleTokenExpired () {
    this.props.triggerPopup(false)
    this.setState({
      showForsiCreatePopup: false,
      showSpinner: false,
      forsiActive: false
    }, () => {
      this.props.setHeaderInfo(SET_HEADERINFO_FORSI, 'action', {
        ForsiTokenActive: false
      })
    })
  }

  updateSpinner () {
    this.setState({ showSpinner: !this.state.showSpinner })
  }

  renderForsiTokenStatus () {
    const { order, forsiTokenActive } = this.props

    if (this.state.showSpinner) {
      return (
        <Grid cols={['min-content', 1, 'max-content']} align='center'>
          <div className='divider' key='1' />
          <div className='invoice' key='2'>
            <span className='animated-background'>
              <i className='fa fa-spinner fa-spin fa-2x fa-fw' />
            </span>
          </div>
        </Grid>
      )
    }

    let isSentToForsi = (order.IsSentToForsi || this.state.isCreated)
    const draftId = order.IsSentToForsi ? order.ForsiDraftId : this.state.isCreated ? this.state.draft ? this.state.draft.id : '' : ''
    const forsiReportIcon = isSentToForsi ? SparePartModuleIcons.OK : SparePartModuleIcons.Attention
    let forsiText = isSentToForsi ? `${translation('16477')}: ${draftId}` : forsiTokenActive ? `${translation('16474')}` : `${translation('16476')}`
    let forsiColor = isSentToForsi ? 'green' : 'orange'

    if (order.HasForsiReport || order.HasBodyShopForsiReport) {
      isSentToForsi = true
      forsiText = translation(16503)
    }

    let action
    if (hasSubscriptionPermission(this.props.auth, 10, 2) && forsiTokenActive && !isSentToForsi) {
      action = this.handleForsiPopup
    }

    return (
      <StatusBox
        onClick={action}
        icon={forsiReportIcon}
        color={forsiColor}
        title={translation(13438).toUpperCase()}
        subTitle={forsiText}
        chevron={this.state.showForsiCreatePopup}
      />
    )
  }

  render () {
    if (!hasAccess([3, 5, 6, 7], this.props.auth.user.UserType)) return null
    if (!hasSubscriptionPermission(this.props.auth, 10)) return null

    return (
      <div>
        {this.props.hasHeader && <PanelHeader text='' />}
        <div className={'white__box invoice_wrapper'}>
          {this.renderForsiTokenStatus()}
        </div>
        {this.state.showForsiCreatePopup && (
          <NewForsiRPModal
            showSpinner={this.updateSpinner}
            show={this.state.showForsiCreatePopup}
            onClose={this.handleForsiPopup}
            onSuccess={this.handleSuccess}
            onTokenExpired={this.handleTokenExpired}
            insuranceCompanies={this.props.forsi}
            order={this.props.order}
          />
        )}
      </div>
    )
  }
}

ForsiCreateReport.defaultProps = {
  onSuccess: null
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    forsiTokenActive: state.common.headerInfo.ForsiTokenActive
  }
}

export default connect(mapStateToProps, {
  triggerPopup,
  setHeaderInfo
})(ForsiCreateReport)



// WEBPACK FOOTER //
// ./src/app/shared/components/ForsiCreateReport/index.js